export enum NavPage {
  HOME = "home",
  CLIENTS = "clients",
  RESSOURCES = "ressources",
  BLOG = "blog",
  ISOLATION = "Isolation",
  AUDIT = "audit",
  GTB = "gtb",
  CVC = "cvc",
  AI_DATA = "ia_data",
  TENDERING = "tendering",
  PROFESSIONNEL = "professionnel",
}

export enum NavAction {
  SERVICES = "services",
  SOLUTIONS = "solutions",
  LOG_IN = "log_in",
  DEMO_OPTEE = "demo_optee",
}

export type NavItem = {
  type: "action" | "page";
  slug: NavAction | NavPage;
  label: string;
  routes?: NavItem[];
  icon?: string;
  url?: string;
};

export enum ServiceColumnTitle {
  OPERATIONS = "Opérations",
  AGIR = "Agir",
  SE_CONFORMER = "Se Conformer",
}

export const NAV_ITEMS: NavItem[] = [
  {
    type: "action",
    slug: NavAction.SOLUTIONS,
    label: "Solutions",
    routes: [
      {
        type: "page",
        slug: NavPage.AI_DATA,
        label: "IA & Data",
        url: "/",
        icon: "gestionnaire",
      },
      {
        type: "page",
        slug: NavPage.TENDERING,
        label: "Appel d’offres",
        url: "/tendering",
        icon: "expertise",
      },
      // {
      //   type: "page",
      //   slug: NavPage.PROFESSIONNEL,
      //   label: "Professionnel",
      //   url: "/professionnel",
      //   icon: "professionnel",
      // },
    ],
    icon: "auto_awesome_mosaic",
  },
  {
    type: "action",
    label: "Opérations",
    slug: NavAction.SERVICES,
    routes: [
      {
        type: "action",
        label: ServiceColumnTitle.OPERATIONS,
        slug: NavAction.SERVICES,
        routes: [
          {
            type: "page",
            slug: NavPage.ISOLATION,
            label: "Isolation",
            icon: "isolation",
            url: "/isolation",
          },
          // {
          //   type : "page",
          //   slug: NavPage,
          //   label: "Eclairage",
          //   icon: "eclairage",
          //   url: "/",
          // },
          {
            type: "page",
            slug: NavPage.GTB,
            label: "GTB",
            icon: "gtb",
            url: "/gtb",
          },
          {
            type: "page",
            slug: NavPage.CVC,
            label: "CVC",
            icon: "cvc",
            url: "/cvc",
          },
          {
            type: "page",
            slug: NavPage.AUDIT,
            label: "Audit Energétique",
            icon: "audit",
            url: "/audit",
          },
        ],
      },
    ],
  },
  {
    type: "page",
    slug: NavPage.PROFESSIONNEL,
    label: "Espace pro",
    url: "/professionnel",
    icon: "professionnel",
  },
  // {
  //   type: "page",
  //   slug: NavPage.CLIENTS,
  //   label: "Clients",
  //   url: "/clients",
  //   icon: "find_in_page",
  // },
  {
    type: "page",
    slug: NavPage.BLOG,
    label: "Ressources",
    url: "/blog",
    icon: "find_in_page",
  },
] as const;
